import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";

const advantages = {
    items: [
        {
            title: "Imagine impecabilă pentru brandul tău",
            text: "Spațiile de prezentare sunt curate în permanență, fără urme, pete sau detalii neglijate care pot afecta percepția clienților.",
        },
        {
            title: "Intervenții fără întreruperea activității",
            text: "Intervenim înainte sau după programul de funcționare, fără a deranja activitatea comercială sau fluxul de vizitatori.",
        },
        {
            title: "Echipe pregătite",
            text: "Echipele noastre sunt pregătite pentru curățenia spațiilor vizibile, cu suprafețe sensibile și cerințe ridicate.",
        },
        {
            title: "Standarde și control al calității",
            text: "Lucrăm după standarde stabilite și verificăm constant calitatea serviciilor.",
        },
        {
            title: "Continuitate și reacție promptă",
            text: "Asigurăm continuitate și reacție promptă în cazul situațiilor neprevăzute.",
        },
    ],
};

const advice = {
    paragraphs: [
        "Mențineți curățenia pe tot parcursul zilei, prevenind acumularea murdăriei.",
        "Întreținerea regulată a pardoselilor și suprafețelor expuse prelungește durata de viață a materialelor.",
        "Colaborarea cu personal neinstruit sau cu firme care nu pot oferi garanții poate duce la deteriorarea suprafețelor sensibile. Este important ca prestatorul să poată răspunde legal și profesional pentru serviciile oferite.",
        "Cereți o probă de lucru într-o zonă mai puțin vizibilă. O probă oferă o imagine clară asupra rezultatului final. Chiar dacă presupune un cost, aceasta vă permite să evaluați eficiența serviciului înainte de aplicarea pe întreaga suprafață.",
        "Solicitați informații despre metodele de lucru și produsele utilizate. Cunoașterea procedurilor și a soluțiilor folosite vă ajută să vă asigurați că acestea sunt adaptate tipului de spațiu și materialelor existente. Verificarea respectării acestora în timpul intervenției este esențială pentru un rezultat constant.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <ServiceGuidance advantages={advantages} advice={advice} />
            </Container>
        </MKBox>
    );
}

export default InformationHome;
